import React from 'react';
import classNames from 'classnames';

import styles from './Button.module.scss';

export interface ButtonPropsI {
  children: React.ReactNode;
  onClick?: () => void;
  variant?:
    | 'fill'
    | 'light'
    | 'round-light'
    | 'text'
    | 'multiple'
    | 'light-blue'
    | 'circle-arrow'
    | 'multiple-switch';
  type?: 'button' | 'submit' | 'reset';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  small?: boolean;
  width?: string;
  disabled?: boolean;
  margin?: string;
  padding?: string;
  borderColor?: string;
  borderWidth?: string;
  backgroundColor?: string;
}

const Button = (props: ButtonPropsI): JSX.Element => {
  const buttonClasses = classNames({
    [styles.Button]: true,
    [styles.Button__fill]: props.variant === 'fill',
    [styles.Button__light]: props.variant === 'light',
    [styles.Button__round_light]: props.variant === 'round-light',
    [styles.Button__text]: props.variant === 'text',
    [styles.Button__multiple]: props.variant === 'multiple',
    [styles.Button__light_blue]: props.variant === 'light-blue',
    [styles.Button__item_small]: props.small,
    [styles.Button__item_circle_arrow]: props.variant === 'circle-arrow',
    [styles.Button__multiple_switch]: props.variant === 'multiple-switch'
  });

  let scale = 1.25;
  switch (props.size) {
    case 'sm':
      scale = 1;
      break;
    case 'md':
      scale = 1.25;
      break;
    case 'lg':
      scale = 2;
      break;
    case 'xl':
      scale = 3;
      break;
    default:
      scale = 0;
      break;
  }

  const style = {
    padding: props.padding ? props.padding : `${scale * 0.5}rem ${scale * 1}rem`,
    width: props.width && props.width,
    margin: props.margin && props.margin,
    borderColor: props.borderColor && props.borderColor,
    borderWidth: props.borderWidth && props.borderWidth,
    backgroundColor: props.backgroundColor && props.backgroundColor
  };

  if (props.variant === 'multiple-switch') {
    return (
      <div className={buttonClasses} style={style} onClick={props.onClick}>
        {props.children}
      </div>
    );
  }

  return (
    <button
      type={props.type}
      className={buttonClasses}
      style={style}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.children}
      <span></span>
    </button>
  );
};

export interface ButtonItemPropsI {
  children: React.ReactNode;
  onClick?: () => void;
  active?: boolean;
  variant?: 'round' | 'elipse';
  padding?: string;
  disabled?: boolean
}

const ButtonItem: React.FC<ButtonItemPropsI> = ({
  children,
  onClick,
  active,
  variant,
  padding,
  disabled
}) => {
  const classes = classNames(styles.Button__item, {
    [styles.Button__item_elipse_active]: active && variant === 'elipse',
    [styles.Button__item_elipse_inactive]: !active && variant === 'elipse',
    [styles.Button__item_round]: variant === 'round',
    [styles.Button__item_round_active]: active && variant === 'round',
    [styles.Button__item_disabled]: disabled,
  });

  return (
    <div onClick={onClick} className={classes} style={{ padding }}>
      {children}
    </div>
  );
};

Button.Item = ButtonItem;

export default Button;
